import React from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import {
  Button,
  IconButton,
  TextField,
  InputAdornment,
} from "@mui/material";
import "./Listing.css";
import { exportResidentColumns, residentColumns } from "./residentColums";
import Search from "@mui/icons-material/Search";
import {
  getresidentStatusList,
} from "../common/constants/globalconstants";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { useEffect } from "react";
//#F2F3F5 alternate color
import { useSelector, useDispatch } from "react-redux";
import { CustomExcelExport } from "../common/CustomExcelExport";
import ErrorModal from "../common/ErrorModal";
import {
  storeUserDetails,
} from "../../action";
import axiosInstance from "../common/AxiosInterceptor";

const customStyle = {
  table: {
    style: {
      border: "1px solid #DEDEDE",
      borderRadius: "5px",
      justifyContent: "center",
    },
  },
  header: {
    style: {
      color: "#193062",
      justifyContent: "center",
    },
  },
  headRow: {
    style: {
      border: "none",
      backgroundColor: "#CDD4DC",
      fontWeight: "bold",
      color: "#002d82",
      fontSize: "14px",
      whiteSpace: "unset",
      justifyContent: "center",
    },
  },
  rows: {
    stripedStyle: {
      backgroundColor: "#F2F3F5",
      justifyContent: "center",
    },
  },
};

function ResidentStatusListings() {
  
  const [delmodal, setdelmodal] = useState(false);

  useEffect(() => console.log("delmodal is called", delmodal), [delmodal]);
  const navigate = useNavigate();
  const location = useLocation();
  const [records, setRecords] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setloading] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [errormodalopen, seterrormodalOpen]= useState(false);
  const [ resetPagination, setRstPagination] = useState(false);
  //const [childCareFacility, setChildCareFacility] = useState("Child1");
  const dispatch = useDispatch();
  //const storetoken = useSelector((state) => state.storetoken);
  const storeuser = useSelector((state) => state.storeuser);
  const userAccessRole = useSelector((state) => state.userAccessRole);
  const {user} = useAuth0();

  //After refresh were loosing user details on this page, added to get the user again
  useEffect(()=>{
    if(storeuser== undefined || storeuser ==null || storeuser == "" ) {
      dispatch(storeUserDetails(user));
    }
  },[storeuser])

    useEffect(() => {
      const getdatafromserver = async() => {
        if(storeuser!==undefined && storeuser!==null && storeuser!==""){
        try{
        setloading(true);
        const resp = await axiosInstance.get(`${getresidentStatusList}?userName=${storeuser.email}`);
            if(resp.data.isSuccess){
            setRecords(resp.data.result);
            setTableData(resp.data.result); //all the original values getting from the server (permanent)
            setExportData(resp.data.result);
            setloading(false);
            seterrormodalOpen(false);
            }
            else if(!resp.data.isSuccess){
              seterrormodalOpen(true);
              setloading(false);
            }
          }
          catch (err) {
            console.log(err.message)
            seterrormodalOpen(true);
            setloading(false);
          };
        }
      };
      getdatafromserver();
    }, [storeuser]);

  const handleChangeInput = (e) => {
    setRstPagination(!resetPagination);
    let searchValue = false;
    let name = false;
    let payee = false;
    let date = false;
    let time = false;
    let status = false;
    let allowance = false;
    let userName = false
    let fullname = false;
    const newdata = tableData && tableData.filter((row) => {
      const fulname = row.payeeFirstName + " " + row.payeeLastName;
      fullname = fulname && fulname
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      name = row.payeeFirstName && row.payeeFirstName
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      payee = row.payeeLastName && row.payeeLastName
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      date = row.achDate && row.achDate
        .toString()
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      time = row.achEDate && row.achEDate
        .toString()
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
        userName= row.userName && row.userName
        .toString()
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());
      status = row.residentStatus && row.residentStatus
        .toLowerCase()
        .includes(e.target.value.toString().toLowerCase());


      if (name) {
        searchValue = name;
      } else if (payee) {
        searchValue = payee;
      } else if (fullname) {
        searchValue = fullname;
      } else if (date) {
        searchValue = date;
      } else if (time) {
        searchValue = time;
      } else if (userName) {
        searchValue = userName;
      } else if (status) {
        searchValue = status;
      } else {
        searchValue = allowance;
      }

      return searchValue;
    });
    setRecords(newdata);
  };

 
  return (
    <div>
      {loading && (
        <>
          <Backdrop
            sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
          >
            <CircularProgress sx={{ color: "white" }} />
            <span> &nbsp;&nbsp;&nbsp;&nbsp; Loading Data... </span>
          </Backdrop>
        </>
      )}
      {/* <div className={records && records.length>0 ? "resident-data-container": "no-resident-data-container"}> */}
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginBottom: ".5rem",
          }}
        >
          <h2 className="header">Resident Status Listing</h2>
          <div className="search-container">
            <TextField
              placeholder="Search"
              type="text"
              variant="outlined"
              onChange={handleChangeInput}
              inputProps={{ className: "search-text" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton>
                      <Search />
                    </IconButton>
                  </InputAdornment>
                ),
                sx: { borderRadius: "5px", height: "40px", textAlign:"center" },
              }}
            />
          </div>
        </div>

          {/*<Grid
                          item
                          sx={{
                            p: "5px 16px",
                            border: "1.5px solid #dfe3e8",
                            borderRadius: "5px",
                            backgroundColor: "white",
                            marginBottom: "5px"
                          }}
                        >
                          <Stack
                            direction="row"
                            alignItems="left"
                            columnGap="2.5rem"
                            justifyContent="left"
                            sx={{ width: "100%", height: "50px", m: "5px 0" }}
                          >
                            <Box
                              display="flex"
                              sx={{
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <p className="input-label-carefacility">Care Facility</p>
                              <TextField
                                select
                                id="care-facility-list"
                                label=""
                                value={childCareFacility}
                                defaultValue="Select"
                                variant="outlined"
                                name="childCareFacility"
                                //onChange={onChangeFacility}
                                sx={{ minWidth: "200px", "& .MuiSelect-select":{ padding: "8px 14px !important"} }}
                                //className="facility-account"
                                SelectProps={{
        
                                  MenuProps: {
                                    PaperProps: {
                                      style: {
                                        maxHeight: 200,
                                      },
                                    },
                                  },
                                }}
                              >
                                
                                <MenuItem key="Child1" value="Child1">Child1</MenuItem>
                                <MenuItem key="Child2" value="Child2">Child2</MenuItem>
                                <MenuItem key="Child3" value="Child3">Child3</MenuItem>
                                <MenuItem key="Child4" value="Child4">Child4</MenuItem>
                              </TextField>
                            </Box>
                           
                          </Stack>
                        </Grid>*/}

        <DataTable
          title=""
          columns={residentColumns}
          data={records}
          pagination
          striped
          highlightOnHover
          customStyles={customStyle}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
          paginationResetDefaultPage={resetPagination}
          paginationPerPage={5}
          paginationComponentOptions={{
            rowsPerPageText: "Records per page",
            rangeSeparatorText: "Out of",
          }}
        />
        <div className="button-container">
          <div className="left-btn-container">
            <Button
              className="back-btn"
              variant="outlined"
              onClick={() => {
                navigate("/home");
              }}
            >
              {" "}
              Back
            </Button>
            {userAccessRole === "Write" ?
            <Button
              className="resident-new-btn"
              variant="contained"
              onClick={() => {
                navigate("/resident", {state: {routeName: location.pathname}});
              }}
            >
              {" "}
              New Resident Status
            </Button>
            : null}
          </div>
          <div>
            {records && records.length>0 ? 
              <CustomExcelExport
                filename="Resident-Listings.xlsx"
                data={records}
                headers={exportResidentColumns}
                >
              </CustomExcelExport>
            :""}
          </div>
        </div>
      </div>
       {errormodalopen && (
        <ErrorModal open={true} onClose={() => seterrormodalOpen(false)} />
      )}
    </div>
  );
}

export default ResidentStatusListings;
